import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { Toaster } from '@/components/ui/Sonner';
import { queryClient } from '@/modules/core/api/queryClient';

const App = (): React.JSX.Element => {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <Outlet />
    </QueryClientProvider>
  );
};

export default App;
